import moment from 'moment'
import { THINX_TIME_FORMAT } from 'shared/time-utilites'
import { DELIVERY_COLLECT_CODE, DELIVERY_EXPRESS_CODE, DELIVERY_STANDART_CODE } from 'subscription-flow/constants'

const mapVehicle = vehicle => ({
    vehicleId: {
        code: 'vehicleId',
        inactive: false,
        value: vehicle.id,
    },
    color: {
        inactive: false,
        value: vehicle.color,
    },
    make: {
        inactive: false,
        value: vehicle.make,
    },
    model: {
        inactive: false,
        value: vehicle.model,
    },
    plateNumber: {
        inactive: false,
        value: vehicle.tag,
    },
})

export const mapVehicles = vehicles => {
    if (!vehicles) {
        return {}
    }

    return {
        extended: {
            fieldMap: {
                vehicles: {
                    fieldList: vehicles.map(vehicle => ({
                        code: 'vehicle',
                        fieldMap: mapVehicle(vehicle),
                    })),
                },
            },
        },
    }
}

export const buildQuery = (valueName, value, fnMap = v => v) =>
    value ? `&${valueName}=${encodeURIComponent(fnMap(value))}` : ''

export const formatDate = startDate => moment(startDate.value).set({ hour: 0 }).format(THINX_TIME_FORMAT)

export const getTaxationItems = items => items.map(item => item?.taxationItems).filter(item => item?.length > 0)

export const getTaxesNames = taxationItems =>
    taxationItems
        .flat()
        .map(item => item.name)
        .filter((name, index, array) => array.indexOf(name) === index)
        .sort()

export const getCurrentTaxTranslatedName = name => {
    switch (name) {
        case 'GST':
            return <T>subscription.purchase.invoice.taxname.gst</T>
        case 'PST':
            return <T>subscription.purchase.invoice.taxname.pst</T>
        case 'HST':
            return <T>subscription.purchase.invoice.taxname.hst</T>
        case 'QST':
            return <T>subscription.purchase.invoice.taxname.qst</T>
        case 'TransLink':
            return <T>subscription.purchase.invoice.taxname.translink</T>
        default:
            return name
    }
}

export const getTaxesTotalNumber = (taxName, taxationItems) =>
    taxationItems
        .flat()
        .filter(item => item.name === taxName)
        .reduce((acc, item) => acc + item.taxAmount, 0)

export const getCredentialDistribution = delivery => {
    switch (delivery.rate.code) {
        case DELIVERY_EXPRESS_CODE:
            return {
                code: 'CREDDISTRIBUTION',
                value: 'EXPMAIL',
            }
        case DELIVERY_STANDART_CODE:
            return {
                code: 'CREDDISTRIBUTION',
                value: 'MAIL',
            }
        case DELIVERY_COLLECT_CODE:
            return {
                code: 'CREDDISTRIBUTION',
                value: 'LOCATION',
            }
        default:
            return {}
    }
}
